import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class SubjectAreaFilterData {
    subjectAreas: Array<DropdownOptionIntegerId>;
}
